// extracted by mini-css-extract-plugin
export default {"PriceFields":"PriceFields_PriceFields__pBppG","Field":"PriceFields_Field__WGGje"};